export default "__VITE_ASSET__CQa7W_W3__"